<template>
    <div class="submain__terrenos-custom">
      <div class="line__vertical-mains"></div>
      <button-back/>
      <div v-if="locations.length > 0" class="map_filter">
        <div class="select__box box-terrenos">
          
          <Range class="ranges-mobile" v-if="locations.length > 0 && rangeFilter.length > 0" :locations="locations" @change="changeRange" :rangeFilter="rangeSliderFilter" :rangeFilterPrice="rangeFilterPrice"/>  
          <Availables
              class="availables-mobile"
              :type="type"
              :existFilter="existFilter"
              :amountAvailables="amountAvailables"
  
  
          />
          <!-- <Promotion class="promotion_mobile">36</Promotion> -->
        </div>
        <div class="maphighlight__box">
            <h1 class="caption__select">
                    <span>Seleccione un terreno, clic para ver detalles</span>
                  </h1>
          <map-highlight class="pradosur-map" :class="extraClass" :img="img"
                         :existFilter="existFilter" :desarrollo="desarrollo" :url="url" :type="type"
                         :nivel="nivel"/>
          <Button :img="img" :id="id"
                  :desarrollo="desarrollo" :nivel="nivel"  :levelId="levelId" :url="url"/>
          <div class="line_horizontal ranges-desk"></div>
          
        </div>
        <div class="select__box">
          <!-- <Select
              v-if="locations.length > 0 && rangeFilter.length > 0"
              :locations="locations"
              @change="changeRange"
              :rangeFilter="rangeFilter"
          /> -->
          <Availables
              class="availables-desk"
              :type="type"
              :existFilter="existFilter"
              :amountAvailables="amountAvailables"
  
          />
          <Range class="ranges-desk" v-if="locations.length > 0 && rangeFilter.length > 0" :locations="locations" @change="changeRange" :rangeFilter="rangeSliderFilter" :rangeFilterPrice="rangeFilterPrice"/>  
           <!--  <Promotion class="promotion_web">36</Promotion> -->
        </div>
      </div>
    </div>
  </template>
  <script>
  import {mapActions, mapGetters} from "vuex";
  import MapHighlight from "../../core/MapHighlight";
  import ButtonBack from "../../core/ButtonBack";
  import Button from "../../core/Button.vue";
  import Availables from "../../core/Availables.vue";
  /* import Select from "../../core/Select.vue"; */
  import Range from "../../core/Range.vue";
  //import Promotion from "../../core/Promotion.vue";
  export default {
    name: "Main",
    components: {
      MapHighlight,
      Button,
      ButtonBack,
      Availables,
     /*  Select, */
     Range,
     //Promotion
    },
    data() {
      return {
        id: 62,
        levelId: this.$route.params.id,
        type: "terreno",
        desarrollo: "pradosur-priv",
        arrFilteredLocations: [],
        nivel: "availability",
        url: `nombre_nivel_te=${this.$route.params.privada}/detalles`,
        micrositeUrl: "https://www.tresmarias.com.mx/pradosur/terrenos",
        privadas: {
           MANZANA1: {
            name: 'manzana1',
            url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/pradosur/manzanas/Manzana1.png',
            width: '1159',
            id: 62, 
            levelId: this.$route.params.id,
            nivel: 'availability',
            route: `nombre_nivel_te=${this.$route.params.privada}/detalles`,
            height: '1531',
            transform: '',
            viewBox: '0 0 1159 1531'
          },
          MANZANA2: {
            name: 'manzana2',
            url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/pradosur/manzanas/Manzana2.png',
            width: '1719',
            id: 62,
            levelId: this.$route.params.id,
            nivel: 'availability',
            route: `nombre_nivel_te=${this.$route.params.privada}/detalles`,
            height: '1612',
            transform: '',
            viewBox: '0 0 1719 1612'
          },
          MANZANA3: {
            name: 'manzana3',
            url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/pradosur/manzanas/Manzana3.png',
            width: '2730',
            id: 62,
            levelId: this.$route.params.id,
            nivel: 'availability',
            route: `nombre_nivel_te=${this.$route.params.privada}/detalles`,
            height: '1576',
            transform: '',
            viewBox: '0 0 2730 1576'
          },
          MANZANA9: {
            name: 'manzana9',
            url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/pradosur/manzanas/Manzana9.png',
            width: '2195',
            id: 62,
            levelId: this.$route.params.id,
            nivel: 'availability',
            route: `nombre_nivel_te=${this.$route.params.privada}/detalles`,
            height: '1100',
            transform: '', 
            viewBox: '0 0 2195 1100'
          },
        },
        //rangeFilterPrice:[1145680,2004051],
        rangeFilters:[
          { min: 92, max: 109.49 },
          { min: 112, max: 232.87 },
        ],
        rangeSliderFilterPriv1:[200,451],
        rangeFilterPricePriv1:[2144890,3600000],
        rangeFilterPriv1:[
          { min: 143.21, max: 154.73 },
          { min: 157.86, max: 290.71 },
        ],
        rangeSliderFilterPriv2:[200,463],
        rangeFilterPricePriv2:[1957855,3691200],
        rangeFilterPriv2:[
          { min: 137.06, max: 184.58 },
          { min: 203.60, max: 882.19 },
        ],
        rangeSliderFilterPriv3:[200,567],
        rangeFilterPricePriv3:[2218370,3959130],
        rangeFilterPriv3:[
          { min: 120.80, max: 168.74 },
          { min: 175.26, max: 843.93 },
        ],
        rangeSliderFilterPriv9:[215,582],
        rangeFilterPricePriv9:[2218370,4596694],
        rangeFilterPriv9:[
          { min: 115.34, max: 191.35 },
          { min: 192.21, max: 1350.10 },
        ],
      };
    },
    computed: {
      ...mapGetters({
        locations: "getLocations",
        filterModelos: "getStatusFilterModelos"
      }),
      extraClass(){
        if(this.$route.params.id==238){
          return 'privada1'
        }else if(this.$route.params.id==239){
          return 'privada2'
        }else{
          return ""
        }
      },
      development() {
        return {id: this.id, level: this.levelId};
      },
      img() {
        const privada = this.$route.params.privada;
        const privadaSeleccionada = this.privadas[privada];
        return privadaSeleccionada;
      },
      amountAvailables() {
        const filteredAvailables = this.existFilter;
        const newArrfiltered = filteredAvailables.filter(
            (item) => item.status == 2
        );
        return newArrfiltered;
      },
      rangeFilter(){
        let selectRangeFileter
        if(this.$route.params.id == 238){
          selectRangeFileter = this.rangeFilterPriv1
        }else if(this.$route.params.id == 239){
          selectRangeFileter = this.rangeFilterPriv2
        }else if(this.$route.params.id == 240){
          selectRangeFileter = this.rangeFilterPriv3
        }else if(this.$route.params.id == 246){
          selectRangeFileter = this.rangeFilterPriv9
        }
        return selectRangeFileter
      },
      rangeSliderFilter(){
        let selectRangeFileter
        if(this.$route.params.id == 238){
          selectRangeFileter = this.rangeSliderFilterPriv1
        }else if(this.$route.params.id == 239){
          selectRangeFileter = this.rangeSliderFilterPriv2
        }else if(this.$route.params.id == 240){
          selectRangeFileter = this.rangeSliderFilterPriv3
        }else if(this.$route.params.id == 246){
          selectRangeFileter = this.rangeSliderFilterPriv9
        }
        return selectRangeFileter
      },
      rangeFilterPrice(){
        let selectRangeFileter
        if(this.$route.params.id == 238){
          selectRangeFileter = this.rangeFilterPricePriv1
        }else if(this.$route.params.id == 239){
          selectRangeFileter = this.rangeFilterPricePriv2
        }else if(this.$route.params.id == 240){
          selectRangeFileter = this.rangeFilterPricePriv3
        }else if(this.$route.params.id == 246){
          selectRangeFileter = this.rangeFilterPricePriv9
        }
        return selectRangeFileter
      },
      existFilter() {
        let arrExistFilter;
        if (this.rangeFilter) {
          arrExistFilter = this.arrFilteredLocations;
        } else if (this.rangeFilter === false) {
          arrExistFilter = this.locations;
        }
       
        return arrExistFilter;
      },
    },
    methods: {
      ...mapActions(["getAvailableLocations", "clearCoords"]),
      changeRange(arrFilter) {
        this.arrFilteredLocations = arrFilter;
      },
  
    },
    async created() {
      await this.getAvailableLocations(this.development);
    },
    async beforeDestroy() {
      await this.clearCoords();
    },
    mounted() {
      
    }
  };
  </script>
<style>
@media (min-width: 651px){
.pradosur-map.privada1 .box__svg{
  width: 45%!important;
}
.pradosur-map.privada2 .box__svg{
  width: 75%!important;
}
}
@media(max-width:650px){
  .pradosur-map.privada1 .box__svg{
  width: 80%!important;
}
.pradosur-map.privada2 .box__svg{
  width: 90%!important;
}
}
</style>
  